import { Controller } from '@hotwired/stimulus';
import BootstrapSelect from '../select/bootstrap-select'
import { easepick, AmpPlugin, RangePlugin, LockPlugin, DateTime } from '@easepick/bundle';

/*
 * This is an example Stimulus controller!
 *
 * Any element with a data-controller="cruisefinder" attribute will cause
 *
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['kinder', 'k', 'red', 'ship', 'type', 'flreed', 'dur', 'region', 'erw', 'hmi', 'bordsprache', 'cab', 'dsi', 'zwi', 'zsi', 'kombitype', 'pdrei', 'dtto', 'dtfrom', 'cabin_type']

    trans = {
        de: {
            selected: 'ausgewählt',
            red: 'Reedereien',
            ship: 'Schiffe',
            region: 'Regionen',
            hmi: 'Abflughäfen',
            dsi: 'Starthäfen',
            zwi: 'Häfen',
            zsi: 'Zielhäfen'
        },
        en: {
            selected: 'selected',
            red: 'Shipping companies',
            ship: 'Ships',
            region: 'Destinations',
            hmi: 'Departure airports',
            dsi: 'Starting ports',
            zwi: 'Ports',
            zsi: 'Destination ports'
        },
        fr: {
            selected: 'sélectionné',
            red: 'Compagnies maritimes',
            ship: 'Navires',
            region: 'Régions',
            hmi: 'Aéroports de départ',
            dsi: 'Ports de départ',
            zwi: 'Ports',
            zsi: 'Ports de destination'
        },
        nl: {
            selected: 'geselecteerd',
            red: 'Rederijen',
            ship: 'Schepen',
            region: 'Regio\'s',
            hmi: 'Luchthavens van vertrek',
            dsi: 'Havens van vertrek',
            zwi: 'Havens',
            zsi: 'Bestemmingshavens'
        },
        it: {
            selected: 'selezionato',
            red: 'Compagnie di navigazione',
            ship: 'Navi',
            region: 'Regioni',
            hmi: 'Aeroporti di partenza',
            dsi: 'Porti di partenza',
            zwi: 'Porti',
            zsi: 'Porti di destinazione'
        },
    }

    selects = {}

    datepicker = {}

    shipOptions = []

    typeValue

    connect() {
        if (this.hasKinderTarget) {
            this.kinderTarget.dispatchEvent(new Event('change'))
        }

        this.element.addEventListener('submit', event => {
            event.preventDefault();

            var params = new URLSearchParams(new FormData(this.element))
            var result = {}

            if (this.hasFlreedTarget) {
                if (false === params.has('flreed')) {
                    result.flreed = 0
                } else {
                    delete result.flreed
                    params.delete('flreed')
                }
            }

            if (2 === parseInt(params.get('erw'))) {
                params.delete('erw');
            }

            if (params.has('kinder')) {
                var kinder = parseInt(params.get('kinder'));
                if (kinder > 0) {
                    for (var k = kinder + 1; k <= 3; k++) {
                        params.delete('k' + k)
                    }
                } else {
                    params.delete('k1')
                    params.delete('k2')
                    params.delete('k3')
                }
                params.delete('kinder')
            }

            params.sort()

            for (const [key, value] of params) {
                if ('' !== value || key === 'sort') {
                    if (key.indexOf('[]') !== -1) {
                        var k = key.replace('[]', '')
                        if (result[k] === undefined) {
                            result[k] = []
                        }
                        result[k].push(value);
                    } else {
                        result[key] = value;
                    }
                }
            }

            // date/range
            if (!IBE.isMobile) {
                if (this.datepicker.range) {
                    result[this.datepicker.range.fromName] = this.datepicker.range.instance.getStartDate().format('YYYY-MM-DD')
                    result[this.datepicker.range.toName] = this.datepicker.range.instance.getEndDate().format('YYYY-MM-DD')
                } else {
                    if (this.datepicker.from) {
                        result[this.datepicker.from.name] = this.datepicker.from.instance.getStartDate().format('YYYY-MM-DD')
                    }
                    if (this.datepicker.to) {
                        result[this.datepicker.to.name] = this.datepicker.to.instance.getStartDate().format('YYYY-MM-DD')
                    }
                }
            }

            window.location = this.element.action + '?' + new URLSearchParams(result).toString() + (this.hasPdreiTarget ? '#xt-dates-and-prices' : '')

            return false;
        })

        // selects
        if (this.hasTypeTarget) {
            this.typeValue = this.typeTarget.value
            this.typeTarget.addEventListener('change', e => {
                const params = new URLSearchParams(window.location.search.substring(1))
                const type = !params.has('t') ? this.typeValue : params.get('t')
                const reset = ['K', 'S', 'NS'].indexOf(type) === -1 || ['K', 'S', 'NS'].indexOf(e.target.value) === -1

                if (reset) {
                    if (this.hasRedTarget) {
                        Array.from(this.redTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                    if (this.hasShipTarget) {
                        Array.from(this.shipTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                    if (this.hasRegionTarget) {
                        Array.from(this.regionTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                    if (this.hasDsiTarget) {
                        Array.from(this.dsiTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                    if (this.hasZwiTarget) {
                        Array.from(this.zwiTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                    if (this.hasZsiTarget) {
                        Array.from(this.zsiTarget.options).forEach(option => {
                            option.selected = false
                        })
                    }
                }

                const resetHmi = (params.has('hmi') || params.has('hmi[]')) && ['R', 'NS'].indexOf(e.target.value) !== -1

                if (resetHmi && this.hasHmiTarget) {
                    Array.from(this.hmiTarget.options).forEach(option => {
                        option.selected = false
                    })
                }
                this.element.dispatchEvent(new Event('submit', { cancelable: true }))
            })

            this.selects.type = new BootstrapSelect(this.typeTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasShipTarget) {
            //if (IBE.isMobile) {
            //    this.shipOptions = Array.from(this.shipTarget.options)
            //    this.buildShipSelect()
            //}

            this.selects.ship = new BootstrapSelect(this.shipTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].ship + ' ' + this.trans[locale].selected
                }
            })
        }

        if (this.hasKombitypeTarget) {
            this.selects.kombitype = new BootstrapSelect(this.kombitypeTarget, {
                //  mobile: IBE.isMobile 
            })
        }

        if (this.hasRedTarget) {
            this.selects.red = new BootstrapSelect(this.redTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].red + ' ' + this.trans[locale].selected
                }
            })

            if (this.hasShipTarget) {
                this.redTarget.addEventListener('change', e => {
                    let values = Array.from(this.redTarget.options).filter(o => o.selected && !o.disabled).map(o => o.value)

                    //if (IBE.isMobile) {
                    if (1 == 2) {
                        if (values.length === 0) {
                            this.shipOptions = this.shipOptions.map(op => {
                                op.disabled = false
                                return op
                            })
                        } else {
                            this.shipOptions = this.shipOptions.map(op => {
                                if (values.indexOf(op.dataset.red) !== -1) {
                                    op.disabled = false
                                } else {
                                    op.disabled = true
                                    op.selected = false
                                }

                                return op
                            })
                        }
                        this.buildShipSelect()
                    } else {
                        if (values.length === 0) {
                            Array.from(this.shipTarget.options).forEach(op => op.disabled = false)
                        } else {
                            Array.from(this.shipTarget.options).forEach(op => {
                                if (values.indexOf(op.dataset.red) !== -1) {
                                    op.disabled = false
                                } else {
                                    op.disabled = true
                                    op.selected = false
                                }
                            })
                        }
                        this.selects.ship?.refresh()
                    }
                })

                this.redTarget.dispatchEvent(new Event('change'))
            }
        }

        if (this.hasRegionTarget) {
            this.selects.region = new BootstrapSelect(this.regionTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].region + ' ' + this.trans[locale].selected
                }
            })
        }

        if (this.hasHmiTarget) {
            this.selects.hmi = new BootstrapSelect(this.hmiTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].hmi + ' ' + this.trans[locale].selected
                }
            })
        }

        if (this.hasKinderTarget) {
            this.selects.kinder = new BootstrapSelect(this.kinderTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasKTarget) {
            this.kTargets.forEach((target, index) => {
                const name = 'k' + (index + 1)
                this.selects[name] = new BootstrapSelect(target, {
                    search: true,
                    hideDisabled: true,
                    //mobile: IBE.isMobile
                })
            })
        }

        if (this.hasErwTarget) {
            this.selects.erw = new BootstrapSelect(this.erwTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasDurTarget) {
            this.selects.dur = new BootstrapSelect(this.durTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasBordspracheTarget) {
            this.selects.bordsprache = new BootstrapSelect(this.bordspracheTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasCabTarget) {
            this.selects.cab = new BootstrapSelect(this.cabTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasCabin_typeTarget) {
            this.selects.cabin_type = new BootstrapSelect(this.cabin_typeTarget, {
                //mobile: IBE.isMobile 
            })
        }

        if (this.hasDsiTarget) {
            this.selects.dsi = new BootstrapSelect(this.dsiTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].dsi + ' ' + this.trans[locale].selected
                }
            })
        }

        if (this.hasZwiTarget) {
            this.selects.zwi = new BootstrapSelect(this.zwiTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].zwi + ' ' + this.trans[locale].selected
                }
            })
        }

        if (this.hasZsiTarget) {
            this.selects.zsi = new BootstrapSelect(this.zsiTarget, {
                hideDisabled: true,
                search: true,
                //mobile: IBE.isMobile,
                multipleCount: (count, locale) => {
                    return count + ' ' + this.trans[locale].zsi + ' ' + this.trans[locale].selected
                }
            })
        }

        // datepickers
        //if(this.hasDtfromTarget || this.hasDttoTarget) {
        if (!IBE.isMobile && (this.hasDtfromTarget || this.hasDttoTarget)) { // only on desktop
            const minDate = new DateTime();
            const year = new Date().getFullYear()

            // range
            if (this.hasDtfromTarget && this.hasDttoTarget) {
                // get labels text for header
                const fromText = this.dtfromTarget.parentElement.querySelector('label').textContent
                const toText = this.dttoTarget.parentElement.querySelector('label').textContent

                const fromName = this.dtfromTarget.name
                const toName = this.dttoTarget.name

                const fromValue = this.dtfromTarget.value
                const toValue = this.dttoTarget.value

                this.dtfromTarget.parentElement.querySelector('label').textContent = IBE.ease.config.header

                const renderHeader = (f, t) => {
                    return '<div class="calendars grid-2">' +
                        '<div class="calendar">' + fromText + ': <strong>' + IBE.formatDpDate(new Date(f)) + '</strong></div>' +
                        '<div class="calendar">' + (t ? toText + ': <strong>' + IBE.formatDpDate(new Date(t)) + '</strong>' : '') + '</div>' +
                        '</div>'
                }

                // remove to and change from to use daterange
                this.dttoTarget.parentElement.remove()

                const input = this.dtfromTarget.cloneNode(true)
                this.dtfromTarget.replaceWith(input)

                this.dtfromTarget.type = 'text'
                this.datepicker.range = {
                    fromName,
                    toName,
                    instance: new easepick.create(Object.assign({
                        element: this.dtfromTarget,
                        zIndex: 1069,
                        grid: 2,
                        calendars: 2,
                        autoApply: true,
                        setup: (picker) => IBE.easeSetup(picker, renderHeader),
                        AmpPlugin: {
                            dropdown: {
                                months: true,
                                years: true,
                                minYear: year,
                                maxYear: year + 3
                            },
                            darkMode: false
                        },
                        RangePlugin: {
                            startDate: new Date(fromValue),
                            endDate: new Date(toValue),
                            locale: IBE.ease.range
                        },
                        LockPlugin: {
                            minDate: minDate,
                            maxDays: 999
                        },
                        plugins: [AmpPlugin, RangePlugin, LockPlugin],
                    }, IBE.ease.config))
                }
            } else {
                delete IBE.ease.config.header;

                if (this.hasDtfromTarget) {
                    const fromName = this.dtfromTarget.name
                    const fromValue = this.dtfromTarget.value
                    this.dtfromTarget.type = 'text'

                    this.datepicker.from = {
                        name: fromName,
                        instance: new easepick.create(Object.assign({
                            element: this.dtfromTarget,
                            date: fromValue,
                            zIndex: 1069,
                            grid: 1,
                            calendars: 1,
                            autoApply: true,
                            setup: IBE.easeSetup,
                            AmpPlugin: {
                                dropdown: {
                                    months: true,
                                    years: true,
                                    minYear: year,
                                    maxYear: year + 3
                                },
                                darkMode: false
                            },
                            LockPlugin: {
                                minDate: minDate,
                                maxDays: 999
                            },
                            plugins: [AmpPlugin, LockPlugin],
                        }, IBE.ease.config))
                    }
                }
                if (this.hasDttoTarget) {
                    const toName = this.dttoTarget.name
                    const toValue = this.dttoTarget.value
                    this.dttoTarget.type = 'text'

                    this.datepicker.to = {
                        name: toName,
                        instance: new easepick.create(Object.assign({
                            element: this.dttoTarget,
                            date: toValue,
                            zIndex: 1069,
                            grid: 1,
                            calendars: 1,
                            autoApply: true,
                            setup: IBE.easeSetup,
                            AmpPlugin: {
                                dropdown: {
                                    months: true,
                                    years: true,
                                    minYear: year,
                                    maxYear: year + 3
                                },
                                darkMode: false
                            },
                            LockPlugin: {
                                minDate: minDate,
                                maxDays: 999
                            },
                            plugins: [AmpPlugin, LockPlugin],
                        }, IBE.ease.config))
                    }
                }
            }
        }
    }

    changeChildren(event) {
        this.kTargets.forEach((select, index) => {
            if (index < parseInt(event.currentTarget.value)) {
                select.parentElement.classList.remove('d-none');
            } else {
                select.parentElement.classList.add('d-none');
                if (select.value) {
                    select.value = '';
                    select.dispatchEvent(new Event('change'));
                }
            }
        })
    }

    changeRed(event) {
        if (!this.hasShipTarget) {
            return
        }

        const values = Array.from(this.redTarget.selectedOptions).map(o => parseInt(o.value))

        if (values.length === 0) {
            Array.from(this.shipTarget.options).forEach(op => {
                op.disabled = false
            });
        } else {
            Array.from(this.shipTarget.options).forEach(op => {
                op.disabled = values.indexOf(parseInt(op.dataset.red)) === -1
            });
        }
    }

    buildShipSelect() {
        const selected = Array.from(this.shipTarget.options).filter(el => el.selected).map(el => el.value)
        this.shipTarget.options.length = 0
        this.shipOptions.forEach(el => {
            if (!el.disabled) {
                this.shipTarget.options.add(new Option(el.textContent, el.value, undefined, selected.indexOf(el.value) !== -1))
            }
        })
        this.selects.ship?.refresh()
    }
}
